import { Link } from "react-router-dom";

const EventCard = ({ event, speaker, onRemove }) => {
    return (
        <div className="event-card">
            {onRemove ? (
                <button className="event-remove" onClick={() => onRemove(event.id)}>
                    {'\u00D7'}
                </button>
            ) : null}
            <div className="event-bubble">
                <div className="top">
                    {(new Date(event.datetime)).toLocaleString({}, {
                        month: 'short'
                    }).toUpperCase()}
                </div>
                <div className="bottom">
                    {(new Date(event.datetime)).getDate().toString().padStart(2, '0')}
                </div>
                <div className="event-time">
                    {(new Date(event.datetime)).getHours() > 12 ? ((new Date(event.datetime)).getHours() - 12) : (new Date(event.datetime)).getHours() == 0 ? 12 : (new Date(event.datetime)).getHours()}
                    :{(new Date(event.datetime)).getMinutes().toString().padStart(2, '0')}
                    &nbsp;{(new Date(event.datetime)).getHours() < 12 ? 'AM' : 'PM'}
                </div>
            </div>
            <div className="name-location">
                <div className="event-name">
                    {event.title}
                </div>
                <div className="event-location">
                    {event.location}
                </div>
            </div>
            <div className="event-time">
                {(new Date(event.datetime)).toLocaleTimeString()}
            </div>
            <div className="event-ticket">
                <Link to={'/event'} state={{id: event.id, speaker}} className="btn">Edit</Link>
            </div>
        </div>
    );
}

export default EventCard;